<mat-toolbar class="toolbar">
  <div id="logoApp">
    <!-- <img class="logo" src="assets/img/Logo_RealGIS.svg" alt="logo"> -->
    SIGApp
    <sub>demo</sub>
  </div>

  <span class="first_spacer"></span>

  <!-- <cdk-virtual-scroll-viewport itemSize="38" class="scroll-widgets"> -->
  <div class="widgetsButtons">
    <!-- <button mat-icon-button matTooltip="Crear un Activo" (click)="changeCreateActive()"
        *ngIf="(loginService.createActive && (homeComponent.activatedViewPanoramic && homeComponent.activatedViewMap) ||  homeComponent.activatedViewPanoramic) ">
        <mat-icon>add_location</mat-icon>
      </button>  -->

    <button mat-icon-button matTooltip="Galeria de Mapas Base"
      (click)="openDialog('DialogBasemapGallery',baseMapGallery)"
      *ngIf="projectEnvironment.modules.baseMapGallery && !homeComponent.activatedViewDashboard">
      <!-- <img class="icon" src="assets/img/SVG/basemapIcon.svg" /> -->
      <mat-icon>dataset</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Lista de Capas"
      (click)="openDialog('DialogLayersList',layerList, position['topRight'])"
      *ngIf="projectEnvironment.modules.layerList && !homeComponent.activatedViewDashboard">
      <!-- <img class="icon" src="assets/img/SVG/layersIcon.svg" /> -->
      <mat-icon>layers</mat-icon>

    </button>
    <!-- <button mat-icon-button matTooltip="Busqueda" (click)="openDialog('DialogSearch',search, position['bottomRight'])"
        *ngIf="projectEnvironment.modules.search && !homeComponent.activatedViewDashboard">
        <mat-icon>search</mat-icon>

        <img class="icon" src="assets/img/SVG/searchIcon.svg" />
      </button> -->
    <!-- <button mat-icon-button matTooltip="Seleccionar"
        (click)="openDialog('DialogSelect',select, position['middleLeft'])"
        *ngIf="projectEnvironment.modules.select && !homeComponent.activatedViewDashboard">
        <mat-icon>select_all</mat-icon>

        <img class="icon" src="assets/img/SVG/selectIcon.svg" />
      </button> -->
    <button mat-icon-button matTooltip="Medir"
      (click)="openDialog('DialogMeasurement',measurement, position['topLeft'])"
      *ngIf="projectEnvironment.modules.measurement && !homeComponent.activatedViewDashboard">
      <mat-icon>straighten</mat-icon>
      <!-- <img class="icon" src="assets/img/SVG/medirIcon.svg" /> -->
    </button>
    <!-- <button mat-icon-button matTooltip="Ver Tabla de Atributos"
        *ngIf="projectEnvironment.modules.tableAttribute && !homeComponent.activatedViewDashboard">
        <mat-icon>table</mat-icon>
        <img class="icon" src="assets/img/SVG/tableIcon.svg" />
      </button> -->
    <button mat-icon-button matTooltip="Añadir Capa"
      (click)="openDialog('DialogAddLayer',addLayer, position['topLeft'])"
      *ngIf="projectEnvironment.modules.addLayer && !homeComponent.activatedViewDashboard">
      <mat-icon>library_add</mat-icon>
      <!-- <img class="icon" src="assets/img/SVG/add_layerIcon.svg" /> -->
    </button>
    <button mat-icon-button matTooltip="Vista General"
      (click)="openDialog('DialogOverview',overView, position['bottomLeft'])"
      *ngIf="projectEnvironment.modules.overviewMap && !homeComponent.activatedViewDashboard">
      <mat-icon>zoom_in_map</mat-icon>
      <!-- <img class="icon" src="assets/img/SVG/expandIcon.svg" /> -->
    </button>
    <button mat-icon-button matTooltip="Imprimir" (click)="openDialog('DialogPrint',print)"
      *ngIf="projectEnvironment.modules.print && !homeComponent.activatedViewDashboard">
      <mat-icon>print</mat-icon>
      <!-- <img class="icon" src="assets/img/SVG/printIcon.svg" /> -->
    </button>
    <!-- <button mat-icon-button matTooltip="Editor" 
      (click)="openEditor()"  *ngIf="projectEnvironment.modules.editor">
        <img class='icon' src="assets/img/SVG/editorIcon.svg" />
      </button> -->
    <button mat-icon-button matTooltip="Leyenda" (click)="toggleLegend()" *ngIf="!homeComponent.activatedViewDashboard">
      <mat-icon>legend_toggle</mat-icon>
      <!-- <img [class]="legendView?'icon-activated':'icon'" src="assets/img/SVG/legendIcon.svg" /> -->
    </button>
    <!-- <mat-divider [vertical]="true"></mat-divider> -->

    <!-- boton en construccion -->
    <!-- <button mat-icon-button  (click)="toggleSidenav()">
        <img class="icon" src="assets/img/SVG/menuIcon.svg" />
      </button> -->
    <!-- boton en construccion -->
  </div>
  <!-- </cdk-virtual-scroll-viewport> -->

</mat-toolbar>